import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { newsCategoryMeta } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function NewsHighlights() {
  const featured = news[0];
  const rest = news.slice(1, 5);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="News"
          title="影视资讯快讯"
          desc="聚焦行业动态、公司新闻、作品发布与人物访谈，把握影视内容的最新脉搏。"
          action={
            <Link
              to="/news/industry"
              className="hidden items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 sm:inline-flex"
            >
              更多资讯
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6">
          <Link
            to={`/detail/news/${featured.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-secondary-100">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 星光传媒资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                {newsCategoryMeta[featured.category].label}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600 md:text-xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" />
                  {featured.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-newspaper-line" />
                  {featured.source}
                </span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-3">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/detail/news/${item.id}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 md:p-4"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-secondary-100 md:w-32">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 星光传媒资讯`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700">
                      {newsCategoryMeta[item.category].label}
                    </span>
                    <span>{item.date}</span>
                  </div>
                  <h4 className="mt-1.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-accent-600 md:text-base">
                    {item.title}
                  </h4>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}